import { createTheme } from "@mui/material/styles";

// Theme utility functions
const linearGradient = (color1, color2) => `linear-gradient(195deg, ${color1}, ${color2})`;

const rgba = (color, opacity) => {
  // Simple hex to rgba
  if (color.startsWith("#")) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  return color;
};

const themeOptions = {
  palette: {
    primary: { main: "#1A73E8", focus: "#1662C4" },
    secondary: { main: "#7B809A", focus: "#6B6F82" },
    info: { main: "#1A73E8", focus: "#1662C4" },
    success: { main: "#4CAF50", focus: "#43A047" },
    warning: { main: "#fb8c00", focus: "#e07C00" },
    error: { main: "#F44335", focus: "#E53935" },
    light: { main: "#f8f9fa", focus: "#e9ecef" },
    dark: { main: "#344767", focus: "#2c3e50" },
    white: { main: "#ffffff", focus: "#f5f5f5" },
    text: { primary: "#344767", secondary: "#525866" },
    background: { default: "#f0f2f5" },
    transparent: { main: "transparent" },
    gradients: {
      primary: { main: "#EC407A", state: "#D81B60" },
      secondary: { main: "#747b8a", state: "#495361" },
      info: { main: "#49a3f1", state: "#1A73E8" },
      success: { main: "#66BB6A", state: "#43A047" },
      warning: { main: "#FFA726", state: "#FB8C00" },
      error: { main: "#EF5350", state: "#E53935" },
      dark: { main: "#42424a", state: "#191919" },
      light: { main: "#EBEFF4", state: "#CED4DA" },
    },
  },
  functions: { linearGradient, rgba },
  boxShadows: {
    xxl: "0px 20px 27px rgba(0, 0, 0, 0.05)",
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: "3rem", fontWeight: 700, lineHeight: 1.25 },
    h2: { fontSize: "2.25rem", fontWeight: 700, lineHeight: 1.3 },
    h3: { fontSize: "1.875rem", fontWeight: 700, lineHeight: 1.375 },
    h4: { fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.375 },
    h5: { fontSize: "1.25rem", fontWeight: 700, lineHeight: 1.375 },
    h6: { fontSize: "1rem", fontWeight: 700, lineHeight: 1.625 },
    body1: { fontSize: "1rem", fontWeight: 400, lineHeight: 1.6 },
    body2: { fontSize: "0.875rem", fontWeight: 400, lineHeight: 1.6 },
    button: { fontSize: "0.75rem", fontWeight: 700, textTransform: "uppercase" },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { scrollBehavior: "smooth" },
        body: {
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          margin: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          borderRadius: "8px",
          fontWeight: 700,
          fontSize: "0.75rem",
          padding: "8px 22px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: "12px" },
      },
    },
  },
};

const theme = createTheme(themeOptions);

export { themeOptions };
export default theme;
